export default {
  SET_LOGGED_USER_DATA: 'SET_LOGGED_USER_DATA',
  SET_LOGGED_USER_PHONE: 'SET_LOGGED_USER_PHONE',

  SET_USER_EXTRA_DATA: 'SET_USER_EXTRA_DATA',
  
  RECEIVE_CONFIRMATION_PIN_DATA: 'RECEIVE_CONFIRMATION_PIN_DATA',

  RECEIVE_USER_BANK_ACCOUNT: 'RECEIVE_USER_BANK_ACCOUNT',
}